<template>
  <div class="container-fluid max-container">
    <div class="row">
      <Header />
      <section>
        <div class="container">
          <div class="health-store-container">
            <h1>Living DNA Store</h1>

            <!-- tab module container starts here -->
            <div class="tab-module-wrapper">
              <div class="tab-module-wrapper-health-store"
                :class="hasBloodTests ? 'tab-module-wrapper-health-store-6' : 'tab-module-wrapper-health-store-5'">
                <div v-for="(tab, index) in tabs" :key="index" @click="selectTab(index)"
                  :class="{ 'active-tab': selectedTab === index }" class="tab-module">
                  <img :src="selectedTab === index ? tab.activeIcon : tab.icon" alt="" />
                  <p class="mt-1 mb-0" :style="{
                    color: selectedTab === index ? 'blue' : 'black',
                    fontWeight: selectedTab === index ? 600 : 400,
                  }">
                    {{ tab.name }}
                  </p>
                </div>
              </div>
              <div v-if="loadingStatus === 'loading'" class="tab-module-progress" aria-hidden="true"></div>
            </div>
            <div class="clear-all-container">
              <a href="#" class="clear" @click="handleClearAll">Clear all</a>
            </div>
            <PageLoader v-if="loadingStatus === 'loading'" />
            <!-- Open div based on the selected tab -->
            <div v-if="selectedTab === 0">
              <!-- <div class="container"> -->
              <div class="card text-start">
                <h2>{{ DigitalWhyToBuy ? DigitalWhyToBuy.heading : ''}}</h2>
                <div class="d-flex flex-column gap-6 mt-sm-4 mt-xl-0">
                  <AncestryKit :main-description="DigitalWhyToBuy ? DigitalWhyToBuy.main_description : ''"  :main-image="DigitalWhyToBuy ? DigitalWhyToBuy.main_image : ''" />
                  <Media :video="DigitalWhyToBuy ? DigitalWhyToBuy.video:''"/>
                  <BenefitKit :sub-description="DigitalWhyToBuy ? DigitalWhyToBuy.sub_description : ''"  :sub-image="DigitalWhyToBuy ? DigitalWhyToBuy.sub_image : ''" />
                  <StoreCarousel :slider-images="DigitalWhyToBuy ? DigitalWhyToBuy.slider_images : ''" :general-text="DigitalWhyToBuy ? DigitalWhyToBuy.general_text:''"/>
                </div>
              </div>
              <!-- </div> -->
              <UpgradesUnavailable v-if="upgradesBlockedFor" :barcode="profileBarcode" :status="upgradesBlockedFor" />
              <p v-if="!upgradesBlockedFor" class="head">Unlock more of your DNA story.</p>
              <div v-if="!upgradesBlockedFor" class="content-tab-container">
                <div
                  v-for="(store, index) in (storeList['Digital upgrade'] ? storeList['Digital upgrade'].filter(store => !store.purchased) : [])"
                  :key="index">
                  <div class="card" v-if="!store.purchased">
                    <div v-if="!store.purchased" class="card-content">
                      <img :src="store.image" class="img-thumbnails" alt="" v-if="store.image !== ''" />
                      <img :src="Bg4" v-else alt="" />
                      <div>
                        <h4 :class="store.locked ? 'disable-color' : ''">{{ store.title }}</h4>
                        <p :class="store.locked ? 'price disable-color' : 'price'">{{ store?.currencySymbol?.raw }} {{
                          getPrice(store?.price) }}</p>
                      </div>
                    </div>
                    <div v-if="!store.purchased" class="card-hover-content">
                      <div class="card-content-hover">
                        <img :src="store.image" class="img-thumbnails" alt="" v-if="store.image !== ''" />
                        <img :src="Bg1" v-else class="w-65" />
                        <h4 :class="store.locked ? 'disable-color' : ''">{{ store.title }}</h4>
                        <p :class="store.locked ? 'price disable-color' : 'price'">{{ store?.currencySymbol?.raw }} {{
                          getPrice(store?.price) }}</p>
                      </div>
                      <span class="truncate-text-multiline" v-html="getDesc(store.shortDescription)"></span>
                      <router-link :to="{ name: 'AncestryDetails', params: { slug: store.slug } }" class="explore-btn"
                        :class="{ 'disabled-link': store.locked }">{{ buttonText(store.categories) }}</router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="selectedTab === 1">
              <!-- <div class="container"> -->
                <div class="card text-start">
                <h2>{{ DnaTestWhyToBuy ? DnaTestWhyToBuy.heading : ''}}</h2>
                <div class="d-flex flex-column gap-6 mt-sm-4 mt-xl-0">
                  <AncestryKit :main-description="DnaTestWhyToBuy ? DnaTestWhyToBuy.main_description : ''"  :main-image="DnaTestWhyToBuy ? DnaTestWhyToBuy.main_image : ''" />
                  <Media :video="DnaTestWhyToBuy ? DnaTestWhyToBuy.video:''"/>
                  <BenefitKit :sub-description="DnaTestWhyToBuy ? DnaTestWhyToBuy.sub_description : ''"  :sub-image="DnaTestWhyToBuy ? DnaTestWhyToBuy.sub_image : ''" />
                  <StoreCarousel :slider-images="DnaTestWhyToBuy ? DnaTestWhyToBuy.slider_images : ''" :general-text="DnaTestWhyToBuy ? DnaTestWhyToBuy.general_text:''"/>
                </div>
              </div>
              <!-- </div> -->
              <p class="head">Purchase additional kits at a discounted price</p>
              <div class="content-tab-container">
                <div v-for="(store, index) in storeList['Kit']" :key="index" class="card">
                  <div class="card-content">
                    <img :src="store.image" class="img-thumbnails" alt="" v-if="store.image !== ''" />
                    <img :src="Bg1" v-else />
                    <h4 :class="store.locked ? 'disable-color' : ''">{{ store.title }}</h4>
                    <p :class="store.locked ? 'price disable-color' : 'price'">{{ store?.currencySymbol?.raw }} {{
                      getPrice(store?.price) }}</p>
                  </div>
                  <div class="card-hover-content">
                    <div class="card-content-hover">
                      <img :src="store.image" class="img-thumbnails" alt="" v-if="store.image !== ''" />
                      <img :src="Bg1" v-else class="w-65" />
                      <div>
                        <h4 :class="store.locked ? 'disable-color' : ''">{{ store.title }}</h4>
                        <p :class="store.locked ? 'price disable-color' : 'price'">{{ store?.currencySymbol?.raw }} {{
                          getPrice(store?.price) }}</p>
                      </div>
                    </div>
                    <span class="truncate-text-multiline" v-html="getDesc(store.shortDescription)"></span>
                    <router-link :to="{ name: 'AncestryDetails', params: { slug: store.slug } }" class="explore-btn"
                      :class="{ 'disabled-link': store.locked }">{{ buttonText(store.categories) }}</router-link>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="selectedTab === 2">
              <!-- <div class="container"> -->
                <div class="card text-start">
                <h2>{{ SupplementWhyToBuy ? SupplementWhyToBuy.heading : ''}}</h2>
                <div class="d-flex flex-column gap-6 mt-sm-4 mt-xl-0">
                  <AncestryKit :main-description="SupplementWhyToBuy ? SupplementWhyToBuy.main_description : ''"  :main-image="SupplementWhyToBuy ? SupplementWhyToBuy.main_image : ''" />
                  <Media :video="SupplementWhyToBuy ? SupplementWhyToBuy.video:''"/>
                  <BenefitKit :sub-description="SupplementWhyToBuy ? SupplementWhyToBuy.sub_description : ''"  :sub-image="SupplementWhyToBuy ? SupplementWhyToBuy.sub_image : ''" />
                  <StoreCarousel :slider-images="SupplementWhyToBuy ? SupplementWhyToBuy.slider_images : ''" :general-text="SupplementWhyToBuy ? SupplementWhyToBuy.general_text:''"/>
                </div>
              </div>
              <!-- </div> -->
              <!-- Mixed from the Wellbeing results, so none is sold before they're in -->
              <WellbeingRequiredPrompt v-if="vitaminsNeedWellbeing" class="store-prompt" />
              <p v-if="!vitaminsNeedWellbeing" class="head">Purchase a vitamin supplement based on your DNA</p>
              <div v-if="!vitaminsNeedWellbeing" class="content-tab-container">
                <div v-for="(store, index) in storeList['Vitamins supplement']" :key="index" class="card">
                  <div class="card-content">
                    <img :src="store.image" class="img-thumbnails" alt="" v-if="store.image !== ''" />
                    <img :src="Bg3" v-else alt="" />
                    <h4 :class="store.locked ? 'disable-color' : ''">{{ store.title }}</h4>
                    <p :class="store.locked ? 'price disable-color' : 'price'">{{ store?.currencySymbol?.raw }} {{
                      getPrice(store?.price) }}</p>
                  </div>
                  <div class="card-hover-content">
                    <div class="card-content-hover">
                      <img :src="store.image" class="img-thumbnails" alt="" v-if="store.image !== ''" />
                      <img :src="Bg1" v-else class="w-65" />
                      <div>
                        <h4 class="text-ellipsis">{{ store.title }}</h4>
                        <p :class="store.locked ? 'price disable-color' : 'price'">{{ store?.currencySymbol?.raw }} {{
                          getPrice(store?.price) }}</p>
                      </div>
                    </div>
                    <span class="truncate-text-multiline" v-html="getDesc(store.shortDescription)"></span>
                    <router-link :to="{ name: 'AncestryDetails', params: { slug: store.slug } }" class="explore-btn">{{
                      buttonText(store.categories) }}</router-link>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="selectedTab === 3">
              <!-- <div class="container"> -->
                <div class="card text-start">
                <h2>{{ MerchandiseWhyToBuy ? MerchandiseWhyToBuy.heading : ''}}</h2>
                <div class="d-flex flex-column gap-6 mt-sm-4 mt-xl-0">
                  <AncestryKit :main-description="MerchandiseWhyToBuy ? MerchandiseWhyToBuy.main_description : ''"  :main-image="MerchandiseWhyToBuy ? MerchandiseWhyToBuy.main_image : ''" />
                  <Media :video="MerchandiseWhyToBuy ? MerchandiseWhyToBuy.video:''"/>
                  <BenefitKit :sub-description="MerchandiseWhyToBuy ? MerchandiseWhyToBuy.sub_description : ''"  :sub-image="MerchandiseWhyToBuy ? MerchandiseWhyToBuy.sub_image : ''" />
                  <StoreCarousel :slider-images="MerchandiseWhyToBuy ? MerchandiseWhyToBuy.slider_images : ''" :general-text="MerchandiseWhyToBuy ? MerchandiseWhyToBuy.general_text:''"/>
                </div>
              </div>
              <!-- </div> -->
              <p class="head">Take your DNA offline with premium merchandise.</p>
              <div class="content-tab-container">
                <div v-for="(store, index) in storeList['Merchandise']" :key="index" class="card">
                  <div class="card-content">
                    <img :src="store.image" class="img-thumbnails" alt="" v-if="store.image !== ''" />
                    <img :src="Bg4" v-else alt="" />
                    <div>
                      <h4 :class="store.locked ? 'disable-color' : ''">{{ store.title }}</h4>
                      <p :class="store.locked ? 'price disable-color' : 'price'">{{ store?.currencySymbol?.raw }} {{
                        getPrice(store?.price) }}</p>
                    </div>
                  </div>
                  <div class="card-hover-content">
                    <div class="card-content-hover">
                      <img :src="store.image" class="img-thumbnails" alt="" v-if="store.image !== ''" />
                      <img :src="Bg1" v-else class="w-65" />
                      <h4 :class="store.locked ? 'text-ellipsis disable-color' : 'text-ellipsis'">{{ store.title }}</h4>
                      <p :class="store.locked ? 'price disable-color' : 'price'">{{ store?.currencySymbol?.raw }} {{
                        getPrice(store?.price) }}</p>
                    </div>
                    <span class="truncate-text-multiline" v-html="getDesc(store.shortDescription)"></span>
                    <router-link :to="{ name: 'AncestryDetails', params: { slug: store.slug } }" class="explore-btn"
                      :class="{ 'disabled-link': store.locked }">{{ buttonText(store.categories, store) }}</router-link>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="selectedTab === 4">
              <!-- A report is made from the kit's DNA results, so none is sold before they're in -->
              <GeneticReportsNotice v-if="reportsWaitForResults" />
              <p v-if="!reportsWaitForResults" class="head">Genetic Reports</p>
              <div v-if="!reportsWaitForResults" class="content-tab-container">
                <div v-for="(store, index) in productList['Genetic Test']" :key="index" class="card">
                  <div class="card-content">
                    <img :src="store?.thumbnail_image[0]?.url" alt="" class="img-thumbnails"
                      v-if="store?.thumbnail_image[0]?.url !== ''" />
                    <img :src="Bg15" v-else alt="" />
                    <div>
                      <h4>{{ store.product_name }}</h4>
                      <p class="price">{{ store?.price_string }}</p>
                    </div>
                  </div>
                  <div class="card-hover-content">
                    <div class="card-content-hover">
                      <img :src="store?.thumbnail_image[0]?.url" class="img-thumbnails" alt=""
                        v-if="store?.thumbnail_image[0]?.url !== ''" />
                      <img :src="Bg6" v-else alt="" />
                      <h4 class="text-ellipsis">{{ store.product_name }}</h4>
                      <p class="price">{{ store?.price_string }}</p>
                    </div>
                    <span class="truncate-text-multiline" v-html="store.product_details"></span>
                    <div class="button-container">
                      <!-- A genetic report is a digital upgrade: AncestryDetails sells it with no
                           delivery address, at the store region's price. -->
                      <router-link :to="{ name: 'AncestryDetails', params: { slug: store._slug } }" class="active-btn">
                        Order
                      </router-link>
                      <router-link :to="{ name: 'AncestryDetails', params: { slug: store._slug } }"
                        class="blood-btn">Explore</router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="selectedTab === 5">
              <p class="head">Blood Tests</p>
              <div class="content-tab-container" v-if="productList['Blood Test']">
                <div v-for="(store, index) in productList['Blood Test']" :key="index" class="card">
                  <div class="card-content">
                    <img :src="store?.thumbnail_image[0]?.url" alt="" class="img-thumbnails"
                      v-if="store?.thumbnail_image[0]?.url !== ''" />
                    <img :src="Bg6" v-else alt="" />
                    <div>
                      <h4>{{ store.product_name }}</h4>
                      <p class="price">{{ store?.price_string }}</p>
                    </div>
                  </div>
                  <div class="card-hover-content">
                    <div class="card-content-hover">
                      <img :src="store?.thumbnail_image[0]?.url" class="img-thumbnails" alt=""
                        v-if="store?.thumbnail_image[0]?.url !== ''" />
                      <img :src="Bg6" v-else alt="" />
                      <h4 class="text-ellipsis">{{ store.product_name }}</h4>
                      <p class="price">{{ store?.price_string }}</p>
                    </div>
                    <span class="truncate-text-multiline" v-html="store.product_details"></span>
                    <div class="button-container">
                      <router-link :to="{ name: 'bloodTestDetails', params: { product: store._id } }" class="active-btn">
                        Order
                      </router-link>
                      <router-link :to="{ name: 'bloodTestDetails', params: { product: store._id } }"
                        class="blood-btn">Explore</router-link>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <p class="data-not">Data not found</p>
              </div>
            </div>

            <ClearAllStoreItems v-if="clearAll" :combinedStoreList="combinedStoreList"
              :productStoreList="productStoreList" :clearAll="clearAll" :Bg1="Bg1" :Bg6="Bg6" />
            <ModalView :isVisible="isModalVisible" :title="'Choose your collection method'" @close="closeModal"
              :isSingleMethod="isSingleMethod">
              <SubscriptionModal :isModalVisible="isModalVisible" :product="productData" @close="closeModal" />
            </ModalView>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useRoute } from "vue-router";
import Header from "@/components/header/Header.vue";
import AncestryKit from "@/components/store/AncestryKit.vue";
import UpgradesUnavailable from "@/components/store/UpgradesUnavailable.vue";
import GeneticReportsNotice from "@/components/kit/GeneticReportsNotice.vue";
import WellbeingRequiredPrompt from "@/components/store/WellbeingRequiredPrompt.vue";
import { useWellbeingResults } from "@/composables/useWellbeingResults";
import { useAncestryKit } from "@/composables/useAncestryKit";
import { statusWithoutResults } from "@/services/kitService";
import Media from "@/components/store/Media.vue";
import BenefitKit from "@/components/store/BenefitKit.vue";
import StoreCarousel from "@/components/store/StoreCarousel.vue";
// import Store from "@/static/store.json";
import { getAllProducts } from "@/store/store/store";
import "../../styles/pages/HealthStore.scss";
import Icon1 from "../../assets/images/Store/solar_medical-kit-broken (1).png";
import Icon1Active from "../../assets/images/Store/solar_medical-kit-broken.png";
import Icon2 from "../../assets/images/Store/Mask group (3).png";
import Icon2Active from "../../assets/images/Store/Mask group (4).png";
import Icon3 from "../../assets/images/Store/Mask group (5).png";
import Icon3Active from "../../assets/images/Store/Mask group (6).png";
import Icon4 from "../../assets/images/Store/Mask group (68).png";
import Icon4Active from "../../assets/images/Store/Mask group (7).png";
import Icon5 from "../../assets/images/Store/Mask group (69).png";
import Icon5Active from "../../assets/images/Store/Mask group (70).png";
import BookIcon from "../../assets/images/Store/book.svg";
import BookIconActive from "../../assets/images/Store/book-active.svg";
import Bg1 from "../../assets/images/Store/image.png";
import Bg3 from "../../assets/images/Store/imagex.png";
import Bg4 from "../../assets/images/Store/image2x.png";
import Bg6 from "../../assets/images/Store/image (8)00.png";
import Bg15 from "../../assets/images/Store/image (10)991.png";
import { usePatientStore } from "@/store/health/blood";
import { groupBy, first } from "lodash";
import ProductService from "@/services/product";
import ClearAllStoreItems from "./ClearAllStoreItems.vue";
import store from '@/store/index'
import { useLoading } from "@/composables/useLoading";
import ModalView from "@/components/Modal/ModalView.vue";
import SubscriptionModal from "@/view/health/Blood/Modal/CollectionMethod.vue";
import { getDigitalUpgradeWhyToBuy, getDnaTestUpgradeWhyToBuy, getSupplementUpgradeWhyToBuy, getMerchandiseUpgradeWhyToBuy } from "@/services/categoryStore.js" ;


// Upgrades are sold for the selected profile's kit; none for a kit that will never give results.
const profileBarcode = computed(() => store.getters?.profile?.profile?.barcode);
// Genetic health reports are made from the kit's or upload's DNA results: none to sell before
// they're in
const { pending: kitPending, uploadPending } = useAncestryKit();
const reportsWaitForResults = computed(() => !profileBarcode.value?.endsWith("E") && (kitPending.value || uploadPending.value));
// Personalised vitamins are mixed from the full Wellbeing test's results: none to sell before then
const { known: wellbeingKnown, hasResults: hasWellbeingResults } = useWellbeingResults();
const vitaminsNeedWellbeing = computed(() => wellbeingKnown.value && !hasWellbeingResults.value);
const upgradesBlockedFor = computed(() => {
  const test = store.getters.selectedTest;
  return test?.barcode === profileBarcode.value ? statusWithoutResults(test) : null;
});

const patientStore = usePatientStore();
const productList = ref([]);
const selectedCategories = ref([]);
const allCategories = ref([]);
const clearData = ref([]);
const { loadingStatus, finishLoading } = useLoading();
const isModalVisible = ref(false);
const productData = ref({});
const products = ref([]);
const DigitalWhyToBuy= ref({});
const DnaTestWhyToBuy= ref({});
const SupplementWhyToBuy= ref({});
const MerchandiseWhyToBuy= ref({});
const storeList = ref({});
// Using ref to track the selected tab and backgrounds
const route = useRoute();
const selectedTab = ref(route.params.tab ? parseInt(route.params.tab, 10) : 0);
const portalKits = [
  "Members-Ancestry-Kit",
  "Members-Ancestry-Wellbeing-Kit",
  "Members-Wellbeing-Kit",
];

function productIsSaleable(product) {
  return product.categories !== "Kit" || portalKits.includes(product.slug);
}
const defaultTabs = [
  { name: "Digital upgrade", icon: Icon3, activeIcon: Icon3Active },
  { name: "DNA Test", icon: Icon1, activeIcon: Icon1Active },
  { name: "Vitamins supplement", icon: Icon2, activeIcon: Icon2Active },
  { name: "Merchandise", icon: BookIcon, activeIcon: BookIconActive },
  { name: "Health Reports", icon: Icon5, activeIcon: Icon5Active },
];

const tabs = computed(() => {
  const tabList = [...defaultTabs]; // Copy default tabs
  if (hasBloodTests.value) {
    tabList.splice(5, 0, { name: "Blood Tests", icon: Icon4, activeIcon: Icon4Active });
  }
  return tabList;
});
const hasBloodTests = computed(() => Boolean(productList.value?.["Blood Test"]?.length));
const isSingleMethod = computed(() => {
  return productData.value.collection_methods && productData.value.collection_methods.length === 1;
});
const closeModal = () => {
  isModalVisible.value = false;
}
function selectTab(index) {
  clearAll.value = false;
  selectedTab.value = index;
}
const clearAll = ref(false);

function handleClearAll() {
  clearAll.value = true;
  selectedTab.value = null;
}

const getPrice = (price) => {
  if (price && price.isOnSale) {
    return price.sale / 100;
  }
  if (price && price.base) {
    return price.base / 100;
  }
  if (price === 0) {
    return "FREE";
  }
  return 0;
}
const buttonText = (category, store) => {
  switch (category) {
    case "Merchandise": {
      const merchandiseItems = storeList?.value?.Merchandise || [];
      const lockedItem = merchandiseItems.find((item) => item.locked);

      if (lockedItem) {
        const dependentSlug = first(store.dependentProducts)?.slug;
        const requiredProduct = products.value.find((item) => item.slug === dependentSlug);
        return `Requires ${requiredProduct?.title}`;
      }
      return "Purchase";
    }
    case "Digital upgrade":
      return "Upgrade";
    default:
      return "Purchase";
  }
}

const getDesc = (desc) => {
  const description = desc.replace(/<\/?[^>]+(>|$)/g, "");
  console.log("description", description);
  return description;

}

onMounted(async () => {
  try {
    await patientStore.getPatient();
    DigitalWhyToBuy.value = await getDigitalUpgradeWhyToBuy();
    DnaTestWhyToBuy.value = await getDnaTestUpgradeWhyToBuy();
    SupplementWhyToBuy.value = await getSupplementUpgradeWhyToBuy();
    MerchandiseWhyToBuy.value = await getMerchandiseUpgradeWhyToBuy();
  } catch (e) {
    console.log(e);
  }
  const code = store.getters.profile.profile.barcode;
  let data = null;
  try {
    data = await ProductService.getAllProducts(code);
    products.value = data;

  } catch (error) {
    console.error('Error fetching product data:', error);
  }
  if (data) {
    const saleableProducts = data.filter(product => {
      return productIsSaleable(product);
    });
    storeList.value = groupBy(saleableProducts, "categories");
  }

  getAllProducts({
    where: {
      age_tags_any: ["All-Ages", patientStore.patient.ageGroup],
      gender_tags_any: [patientStore.patient.bioSex],
      wellbeing_goal_tags_any: patientStore.patient.questionnaireAnswers?.wellbeing_goals,
    },
  })
    .then((products) => {

      productList.value = groupBy(
        products,
        "product_type"
      );
      clearData.value = productList.value;


      selectedCategories.value = Object.keys(productList.value);

      if (data && Array.isArray(data) && data.length > 0) {
        const dataCategories = Object.keys(storeList.value);
        allCategories.value = [...selectedCategories.value, ...dataCategories];
      }
    })
    .finally(() => {
      finishLoading();
    });
});
const combinedStoreList = computed(() => {
  if (clearAll.value) {
    const storeItems = Object.values(storeList.value).flat();
    return [...storeItems];
  }
  return [];
});

const productStoreList = computed(() => {
  if (clearAll.value) {
    const storeItems = Object.values(clearData.value).flat();
    return [...storeItems];
  }

  return [];
});
</script>

<style lang="scss" scoped>
// In place of a tab's products: a prompt to the way to get them
.store-prompt {
  max-width: 640px;
  margin: 24px auto;
}
</style>
